import React from 'react';
import { Helmet } from 'react-helmet-async';

interface StructuredDataProps {
  type?: 'organization' | 'website' | 'jobPosting';
  data?: any;
}

export const StructuredData: React.FC<StructuredDataProps> = ({ type = 'organization', data }) => {
  const getStructuredData = () => {
    switch (type) {
      case 'organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Utvecklare Direkt",
          "alternateName": "UtvecklareDirekt",
          "url": "https://www.utvecklaredirekt.se",
          "logo": "https://www.utvecklaredirekt.se/images/utvecklaredirekt_fav_icon.png",
          "description": "Utvecklare Direkt kopplar samman svenska företag med skickliga ukrainska mjukvaruutvecklare för fjärrarbete.",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "SE"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Customer Service",
            "availableLanguage": ["Swedish", "English", "Ukrainian"]
          },
          "sameAs": [
            "https://www.utvecklaredirekt.se"
          ],
          "foundingDate": "2024",
          "keywords": "ukrainska utvecklare, svenska företag, fjärrarbete, mjukvaruutveckling, React, TypeScript, Node.js, frontend, backend"
        };

      case 'website':
        return {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "Utvecklare Direkt",
          "url": "https://www.utvecklaredirekt.se",
          "description": "Hitta kvalificerade ukrainska utvecklare för fjärrarbete",
          "inLanguage": "sv-SE"
        };

      case 'jobPosting':
        return data ? {
          "@context": "https://schema.org",
          "@type": "JobPosting",
          "title": data.title || "Remote Software Developer",
          "description": data.description || "Experienced software developer available for remote work",
          "hiringOrganization": {
            "@type": "Organization",
            "name": "Utvecklare Direkt",
            "sameAs": "https://www.utvecklaredirekt.se"
          },
          "jobLocationType": "TELECOMMUTE",
          "applicantLocationRequirements": {
            "@type": "Country",
            "name": "Sweden"
          },
          "employmentType": ["CONTRACTOR", "PART_TIME", "FULL_TIME"],
          "datePosted": data.datePosted || new Date().toISOString().split('T')[0],
          "validThrough": data.validThrough || new Date(Date.now() + 90 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
          "baseSalary": {
            "@type": "MonetaryAmount",
            "currency": "SEK",
            "value": {
              "@type": "QuantitativeValue",
              "unitText": "HOUR"
            }
          }
        } : null;

      default:
        return null;
    }
  };

  const structuredData = getStructuredData();

  if (!structuredData) return null;

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};